import './App.css';
import AppContainer from './layouts/app-container';
import SosContainer from './layouts/sos-container';
import ResponsiveAppBar from './layouts/ResponsiveAppBar';
import { BrowserRouter } from 'react-router-dom';

export default function App() {
  return (
    <BrowserRouter>
      <ResponsiveAppBar />
    </BrowserRouter>
  );
}
